import * as types from './actionTypes';

const initialState = {
  salary_scale: null,
  loading: false,
  error: null,
  success: false,
};

const salaryScaleReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_SALARY_SCALE:
    case types.SAVE_SALARY_SCALE:
    case types.CHANGE_SALARY_SCALE_STATUS:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case types.FETCH_SALARY_SCALE_SUCCESS:
      return {
        ...state,
        salary_scale: action.payload?.data,
        loading: false,
        success: false,
      };

    case types.SAVE_SALARY_SCALE_SUCCESS:
    case types.CHANGE_SALARY_SCALE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case types.FETCH_SALARY_SCALE_FAILURE:
    case types.SAVE_SALARY_SCALE_FAILURE:
    case types.CHANGE_SALARY_SCALE_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    default:
      return state;
  }
};

export default salaryScaleReducer;
